import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import PropertyCard from "@/components/PropertyCard";

export default function Wishlist() {
  const [items, setItems] = useState([]);
  const [ids, setIds] = useState(new Set());
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/wishlist")
      .then((r) => {
        setItems(r.data.properties || []);
        setIds(new Set(r.data.property_ids || []));
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handleWishlistChange = (id, inList) => {
    setIds((prev) => {
      const next = new Set(prev);
      if (inList) next.add(id); else next.delete(id);
      return next;
    });
    if (!inList) setItems((prev) => prev.filter((p) => p.id !== id));
  };

  return (
    <div className="mx-auto max-w-7xl px-6 md:px-10 py-12" data-testid="wishlist-page">
      <p className="text-xs uppercase tracking-[0.25em] text-[hsl(10_51%_55%)]">Your favourites</p>
      <h1 className="font-serif-display text-3xl sm:text-4xl mt-2 mb-10">Saved stays</h1>

      {loading ? (
        <div className="text-center py-16 text-[hsl(100_3%_30%)]">Loading…</div>
      ) : items.length === 0 ? (
        <div className="text-center py-16">
          <p className="font-serif-display text-2xl mb-3">Your wishlist is empty.</p>
          <p className="text-[hsl(100_3%_30%)] mb-6">Tap the heart on any stay to save it here.</p>
          <Link to="/search" className="inline-flex items-center btn-terracotta rounded-full px-6 py-3 text-sm">Browse stays</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {items.map((p) => (
            <PropertyCard key={p.id} property={p} isWishlisted={ids.has(p.id)} onWishlistChange={handleWishlistChange} />
          ))}
        </div>
      )}
    </div>
  );
}
